import { constants as config } from '@config';

function getMatchedType (resourceType) {
  const lowerCaseType = resourceType.toLowerCase();

  return config.smartAssets.types
    .find(type => type === lowerCaseType || type.includes(lowerCaseType));
}

function classifyResources (payload) {
  const resources = [].concat(payload);

  return resources.reduce((result, resource) => {
    if (resource.type === 'Palette' && Array.isArray(resource.data?.colors)) {
      return result.concat(classifyResources(resource.data?.colors));
    }

    const type = getMatchedType(resource.type);
    if (!type) return result;

    return result.concat({
      ...resource,
      type
    });
  }, []);
}

export function setAssets (payload) {
  return {
    payload: classifyResources(payload)
  };
}
